import React, { useEffect, useRef, useState } from "react";
// import "./AudioVisualizer.css";

const AudioVisualizer = () => {

    const audioRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);
    const [playedBars, setPlayedBars] = useState(0);

    /* CONFIG */
    const totalWidth = 277;
    const barWidth = 4;
    const gap = 3.5;
    const svgHeight = 30;

    const totalBars = Math.floor(
        totalWidth / (barWidth + gap)
    );

    /* CREATE BARS */
    const bars = Array.from(
        { length: totalBars },
        (_, i) => {

            const baseHeight =
                Math.random() * 15 + 10;

            return {
                id: i,
                height: baseHeight,
                x: i * (barWidth + gap),
                duration:
                    Math.random() * 0.6 + 0.5
            };
        }
    );

    

    /* UPDATE PROGRESS */
    useEffect(() => {

        let interval;

        if (isPlaying) {

            interval = setInterval(() => {

                const audio = audioRef.current;

                if (!audio || !audio.duration) return;

                const progress =
                    (audio.currentTime /
                        audio.duration) *
                    100;

                const activeBars =
                    Math.floor(
                        (progress / 100) *
                            totalBars
                    );

                setPlayedBars(activeBars);

            }, 100);
        }

        return () => clearInterval(interval);

    }, [isPlaying]);

    /* PLAY / PAUSE */
    const handlePlayPause = async () => {

        const audio = audioRef.current;

        if (!audio) return;

        if (!isPlaying) {

            try {

                await audio.play();

                setIsPlaying(true);

            } catch (err) {

                console.warn(err);
            }

        } else {

            audio.pause();

            setIsPlaying(false);
        }
    };

    /* AUDIO ENDED */
    const handleEnded = () => {

        setIsPlaying(false);
        setPlayedBars(0);
    };

    useEffect(()=>{
        handlePlayPause();
    }, [])

    return (
        <div className="amrt_player-pill">
            <audio ref={audioRef} src="images/Radio-200000-Langschtrass.mp3"/>
            <button className="amrt_play-btn" onClick={handlePlayPause}>
                {isPlaying ? (
                    <img src="images/pause-button.svg" alt="Pause" />
                ) : (
                    <img src="images/play-button.svg" alt="Play" />
                )}
            </button>
            <svg id="amrt_visualizer" width={totalWidth} height={svgHeight}>
                {bars.map((bar, index) => (
                    <rect key={bar.id} x={bar.x} y={ (svgHeight - bar.height) / 2 } width={barWidth} height={bar.height} rx={barWidth / 2}
                        // className={`amrt_bar ${
                        //     index <= playedBars
                        //         ? "amrt_played"
                        //         : ""
                        // }`}
                        className={`amrt_bar ${index <= playedBars ? "amrt_played" : ""} ${!isPlaying ? "amrt_paused" : ""} `} style={{ animationDuration: `${bar.duration}s` }}
                    />
                ))}
            </svg>
        </div>
    );
};

export default AudioVisualizer;